export default __webpack_public_path__ + "static/media/tom-yum-spaghetti.68b4b557.png";